

// import React from "react";
// import { Link } from "react-router-dom";

// const SidebarAbout = () => {
//   return (
//     <div className=" h-screen p-4">
//       <ul className="space-y-4">
//         <li className="text-gray-700 bg-gray-100 hover:bg-gray-300 p-3 rounded-lg">
//           <Link to="/about" className="block w-full h-full">
//             About Moveonwheels
//           </Link>
//         </li>
//         <li className="text-gray-700 bg-gray-100 hover:bg-gray-300 p-3 rounded-lg">
//           <Link to="/about/trip" className="block w-full h-full">
//             Your Trip
//           </Link>
//         </li>
//         <li className="text-gray-700 bg-gray-100 hover:bg-gray-300 p-3 rounded-lg">
//           <Link to="/about/payment" className="block w-full h-full">
//             Payments & Refunds
//           </Link>
//         </li>
//         <li className="text-gray-700 bg-gray-100 hover:bg-gray-300 p-3 rounded-lg">
//           <Link to="/about/your-booking" className="block w-full h-full">
//             Your Booking
//           </Link>
//         </li>
//         <li className="text-gray-700 bg-gray-100 hover:bg-gray-300 p-3 rounded-lg">
//           <Link to="/about/wallet-faq" className="block w-full h-full">
//             Wallet
//           </Link>
//         </li>
//         <li className="text-gray-700 bg-gray-100 hover:bg-gray-300 p-3 rounded-lg">
//           <Link to="/about/refer" className="block w-full h-full">
//             Refer A Friend
//           </Link>
//         </li>
//       </ul>
//     </div>
//   );
// };

// export default SidebarAbout;




// import React, { useState } from "react";
// import AboutUs from "./AboutUs";
// import YourTrip from "./YourTrip";
// import PaymentsRefunds from "./PaymentsRefunds";
// import YourBooking from "./YourBooking";
// import Wallet from "./Wallet";

// const SidebarAbout = () => {
//   const [ModalContent, setModalContent] = useState(null);

//   const openModal = (Component) => setModalContent(<Component />);
//   const closeModal = () => setModalContent(null);

//   return (
//     <div className="h-screen p-4 ">
//       <ul className="space-y-4">
//         <li><button onClick={() => openModal(AboutUs)}>About Moveonwheels</button></li>
//         <li><button onClick={() => openModal(YourTrip)}>Your Trip</button></li>
//         <li><button onClick={() => openModal(PaymentsRefunds)}>Payments & Refunds</button></li>
//         <li><button onClick={() => openModal(YourBooking)}>Your Booking</button></li>
//         <li><button onClick={() => openModal(Wallet)}>Wallet</button></li>
//       </ul>

//       {ModalContent && (
//         <div className="fixed inset-0 bg-gray-800 bg-opacity-50 flex items-center justify-center">
//           <div className="bg-white p-6 rounded-lg">
//             <button className="absolute top-2 right-2" onClick={closeModal}>&times;</button>
//             {ModalContent}
//           </div>
//         </div>
//       )}
//     </div>
//   );
// };

// export default SidebarAbout;

import React, { useState } from "react";
import AboutUs from "./AboutUs";
import YourTrip from "./YourTrip";
import PaymentsRefunds from "./PaymentsRefunds";
import YourBooking from "./YourBooking";
import Wallet from "./Wallet";

const SidebarAbout = () => {
  const [ModalContent, setModalContent] = useState(null);

  const openModal = (Component) => setModalContent(<Component />);
  const closeModal = () => setModalContent(null);

  return (
    <div className="h-screen flex  justify-center bg-white mt-4">
      <ul className="space-y-4 w-full p-4 font-semibold ">
        {[
          { label: "About Moveonwheels", Component: AboutUs },
          { label: "Your Trip", Component: YourTrip },
          { label: "Payments & Refunds", Component: PaymentsRefunds },
          { label: "Your Booking", Component: YourBooking },
          { label: "Wallet", Component: Wallet },
        ].map((item, index) => (
          <li key={index}>
            <button
              onClick={() => openModal(item.Component)}
              className="w-full p-4 bg-gray-100 border rounded-lg hover:bg-gray-200 text-center"
            >
              {item.label}
            </button>
          </li>
        ))}
      </ul>

      {ModalContent && (
        <div className="fixed inset-0 bg-gray-800 bg-opacity-50 flex items-center justify-center">
          <div className="bg-white rounded-lg relative">
            <button
              className="absolute top-2 right-2 text-gray-500 hover:text-gray-700"
              onClick={closeModal}
            >
              &times;
            </button>
            {ModalContent}
          </div>
        </div>
      )}
    </div>
  );
};

export default SidebarAbout;
